/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SignupCompletionField = {
    Name: 'NAME',
    TermsAndConditions: 'TERMS_AND_CONDITIONS',
    MarketingEmailsOptIn: 'MARKETING_EMAILS_OPT_IN',
    SocialLogin: 'SOCIAL_LOGIN',
    FreelancingExperience: 'FREELANCING_EXPERIENCE',
    ImportResume: 'IMPORT_RESUME',
    WorkExperiences: 'WORK_EXPERIENCES',
    Educations: 'EDUCATIONS',
    Headline: 'HEADLINE',
    Categories: 'CATEGORIES',
    ExperienceLevel: 'EXPERIENCE_LEVEL',
    RegularSkills: 'REGULAR_SKILLS',
    StrategySkills: 'STRATEGY_SKILLS',
    IndustryExpertises: 'INDUSTRY_EXPERTISES',
    Languages: 'LANGUAGES',
    DailyRate: 'DAILY_RATE',
    LocationAndWorkplacePreference: 'LOCATION_AND_WORKPLACE_PREFERENCE',
    ProfilePicture: 'PROFILE_PICTURE',
    PhoneNumber: 'PHONE_NUMBER',
    PrivacyOptOut: 'PRIVACY_OPT_OUT',
    StrategyBackground: 'STRATEGY_BACKGROUND'
} as const;
export type SignupCompletionField = typeof SignupCompletionField[keyof typeof SignupCompletionField];


export function instanceOfSignupCompletionField(value: any): boolean {
    for (const key in SignupCompletionField) {
        if (Object.prototype.hasOwnProperty.call(SignupCompletionField, key)) {
            // @ts-ignore
            if (SignupCompletionField[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SignupCompletionFieldFromJSON(json: any): SignupCompletionField {
    return SignupCompletionFieldFromJSONTyped(json, false);
}

export function SignupCompletionFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignupCompletionField {
    return json as SignupCompletionField;
}

export function SignupCompletionFieldToJSON(value?: SignupCompletionField | null): any {
    return value as any;
}

